/*
 * SundayBuilder · Screen 3 · Discernment
 * ---------------------------------------------------------------------
 * Contemplative loading state. Three bronze glyphs (wheat · grapes ·
 * host) pulse asynchronously. A single rotating status line describes
 * the current step. No progress bar, no percentage — time is uncertain
 * by design.
 * =================================================================== */
import { useEffect, useState } from "react";

const STEPS = [
  "Consulting the lectionary…",
  "Weighing your parish's living memory…",
  "Discerning suggested repertoire…",
  "Drafting the pastoral letter…",
  "Sealing the reasoning passport…",
];

function WheatGlyph() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" aria-hidden="true">
      <path d="M12 3v18" /><path d="M12 6c-2 0-3 2-3 4s1 4 3 4" />
      <path d="M12 6c2 0 3 2 3 4s-1 4-3 4" /><path d="M12 12c-2 0-3 2-3 4s1 4 3 4" />
      <path d="M12 12c2 0 3 2 3 4s-1 4-3 4" />
    </svg>
  );
}
function GrapeGlyph() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" aria-hidden="true">
      <circle cx="12" cy="7" r="2.2" /><circle cx="8" cy="11" r="2.2" /><circle cx="16" cy="11" r="2.2" />
      <circle cx="10" cy="15" r="2.2" /><circle cx="14" cy="15" r="2.2" /><circle cx="12" cy="19" r="2.2" />
      <path d="M12 3v2" />
    </svg>
  );
}
function HostGlyph() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" aria-hidden="true">
      <circle cx="12" cy="12" r="8" /><path d="M12 6v12" /><path d="M6 12h12" />
    </svg>
  );
}

export default function Discernment() {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setIdx((n) => (n + 1) % STEPS.length), 3200);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      className="sb-screen"
      data-testid="sb-discernment"
      style={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <div style={{ display: "flex", gap: 32, marginBottom: 48 }}>
        {[WheatGlyph, GrapeGlyph, HostGlyph].map((Glyph, i) => (
          <span
            key={i}
            style={{
              width: 40, height: 40,
              color: "var(--li-cast-bronze)",
              opacity: 0.4,
              animation: "sbGlyphPulse 3.6s ease-in-out infinite",
              animationDelay: `${i * 1.2}s`,
              display: "inline-block",
            }}
          >
            <Glyph />
          </span>
        ))}
      </div>
      <h1 style={{
        fontFamily: "var(--li-font-display)",
        color: "var(--li-text-primary)",
        fontSize: "2.25rem",
        fontWeight: 600,
        margin: "0 0 14px",
      }}>
        Preparing your dossier
      </h1>
      <p
        role="status"
        aria-live="polite"
        data-testid="sb-discernment-status"
        style={{
          fontFamily: "var(--li-font-body)",
          color: "var(--li-text-secondary)",
          fontSize: "1.125rem",
          minHeight: "1.5em",
          transition: "opacity 0.6s ease",
        }}
      >
        {STEPS[idx]}
      </p>
      <style>{`
        @keyframes sbGlyphPulse {
          0%, 100% { opacity: 0.25; transform: translateY(0); }
          50%      { opacity: 0.85; transform: translateY(-4px); }
        }
      `}</style>
    </div>
  );
}
